module.exports = __webpack_public_path__ + "static/media/honestidad.3c39e9b6.jpg";